import { ServiceBase, Result } from "./ServiceBase";
import { EmProduct } from '../models/EmProduct';

export default class EmProductService extends ServiceBase {

    public static async listByDivision(divisionId: string): Promise<Result<EmProduct[]>> {

        var result = await this.requestJson<EmProduct[]>({
            url: `/api/EmProduct/listByDivision/${divisionId}`,
            method: "GET"            
        });

        return result;
    }

    public static async listByParentProduct(parentId: string): Promise<Result<EmProduct[]>> {

        var result = await this.requestJson<EmProduct[]>({
            url: `/api/EmProduct/list/${parentId}`,
            method: "GET"
        });

        return result;
    }

    public static async list(): Promise<Result<EmProduct[]>> {

        var result = await this.requestJson<EmProduct[]>({
            url: `/api/EmProduct/list/`,
            method: "GET"
        });

        return result;
    }
}
